import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-1" }
const _hoisted_2 = { class: "text-sm divide-y dark:divide-gray-900" }
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ml-1 text-gray-500 text-xs flex items-center",
    style: {"color":"#fcfcfc"}
  }, [
    /*#__PURE__*/_createTextVNode(" To learn more about how to create a pool, please go to our "),
    /*#__PURE__*/_createElementVNode("a", {
      style: {"margin-left":"5px","color":"#8F93D6"},
      target: "_blank",
      href: "https://modrianswap.gitbook.io/modrianswap/about-us/faq/getting-started-on-mondrianswap/how-do-i-create-a-custom-pool"
    }, "documentation")
  ])
], -1)

import { computed } from 'vue';

export default _defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBreakdown = _resolveComponent("BalBreakdown")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!

  return (_openBlock(), _createBlock(_component_BalTooltip, {
    width: "auto",
    noPad: ""
  }, {
    activator: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BalIcon, _mergeProps({
          name: "info",
          size: "sm",
          class: "text-gray-400 dark:text-gray-500"
        }, _ctx.$attrs), null, 16)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BalBreakdown, { hideItems: false }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})